import { styled } from '@material-ui/core/styles';

export const LoaderContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%'
});

export const NotificationTextDiv = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(1)
}));
